import { usePatchPositionV2 } from '@/clients/position/usePatchPositionV2.ts';
import { FunctionComponent, useCallback } from 'react';
import { constructPositionConfiguration } from '@/modules/position/components/PositionSummary/utils/constructPositionConfiguration.ts';
import { FinanceSettingsFormRendererProps } from '@/modules/position/components/PositionSummary/PositionSummary.tsx';

type EditPositionSummaryProps = {
    positionId: string;
    FinanceSettingsFormRenderer: FunctionComponent<FinanceSettingsFormRendererProps>;
};

export const EditPositionSummary = ({ positionId, FinanceSettingsFormRenderer }: EditPositionSummaryProps) => {
    const { mutateAsync, isPending, isSuccess } = usePatchPositionV2(positionId);

    const handleSubmit = useCallback(
        async (positionConfiguration: ReturnType<typeof constructPositionConfiguration>) => {
            const updatedPosition = await mutateAsync(positionConfiguration);

            return { id: updatedPosition.id, positionNumber: updatedPosition.number };
        },
        [mutateAsync]
    );

    return <FinanceSettingsFormRenderer isSuccess={isSuccess} isPending={isPending} onSubmit={handleSubmit} />;
};
